export function addAnonIdToParams(
    params: Record<string, string>,
    analyticsClient: { getAnonymousId: () => string } | null
): Record<string, string> {
    const anonymousId = analyticsClient?.getAnonymousId();
    if (!anonymousId) {
        return params;
    }
    return { ...params, anon_id: anonymousId };
}
